import { render, staticRenderFns } from "./PurchaseInsurance.vue?vue&type=template&id=7613c098"
import script from "./PurchaseInsurance.vue?vue&type=script&lang=js"
export * from "./PurchaseInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports